import React from 'react';
import { IoMdClose } from 'react-icons/io';
import './style.scss';

export const MobileModal = ({ onClose, children }) => {
  return (
    <div className="cv-mobile-modal fade__in">
      <IoMdClose
        onClick={() => onClose()}
        className="cv-mobile-modal__close"
        color="#FFF"
        size={28}
      />
      {children}
    </div>
  );
};
